import React from 'react'

export default function Footer(props) {
    return (
        <div className={`footer ${props.mode}`}>
             Copyright &copy; www.TextUtils_Shiv.com. All rights reserved!
        </div>
    )
}
